import AddToCart, { AddToCartForm } from './AddToCart';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withAddToCart from './withAddToCart';
import formatPrismicData from '../../hocs/formatPrismicData';
import withProduct from '../../hocs/withProduct';

const enhance = compose(
  formatPrismicData,
  withProps(props => ({
    productId: props.addToCart.main.productId,
    cta: props.ctaOverride || props.addToCart.form.cta
  })),
  withProduct,
  withAddToCart,
);

export const EnhancedAddToCartForm = enhance(AddToCartForm);
export default enhance(AddToCart);



// WEBPACK FOOTER //
// ./src/client/js/view/components/AddToCart/index.js